import { Disclosure } from '@headlessui/react'
import React from 'react'
import Chevron from './icons/chevron'
import RollingHills from './icons/rolling-hills'

export default function Accordions({ props }) {
    const { accordions, heading, content } = props
    return (
        <>
            <section
                className={`bg-banner-gradient relative py-12 lg:py-20 print:bg-transparent`}
            >
                <RollingHills />
                <div className={`container`}>
                    <div className="max-w-4xl mx-auto md:text-center mb-10 text-white">
                        {heading ? <h2 className="mb-2">{heading}</h2> : null}
                        {content ? <div className="parsed-content" dangerouslySetInnerHTML={{ __html: content }} /> : null}
                    </div>
                    {accordions ?
                        <ul className="max-w-4xl mb-6 grid gap-6 lg:gap-8 mx-auto">
                            {accordions?.map((accordion) => {
                                return (<Accordion props={accordion} key={accordion.button} />)
                            })}
                        </ul>
                        : null}
                </div>
            </section>
        </>
    )
}

function Accordion({ props }) {
    const { button, panel } = props
    return (
        <Disclosure
            as="li"
            className="-mx-2 bg-white/90 relative rounded"
        >
            {({ open }) => (
                <>
                    <dt>
                        <Disclosure.Button className={`text-left w-full flex justify-between items-start ${open ? "rounded-t" : "rounded"} transition hover:bg-green group hover:bg-opacity-10 py-4 px-5`}>
                            <h3 className="grow font-medium">
                                {button}
                            </h3>
                            <span className="ml-6 h-4 inline-flex my-auto items-center opacity-60 group-hover:opacity-100 print:hidden" aria-hidden={true}>
                                <Chevron className={`${open ? "-rotate-90" : "rotate-90"} h-4 w-4 transform`} />
                            </span>
                        </Disclosure.Button>
                        <Disclosure.Panel as="dd" className="mt-2 px-5 pt-0.5 pb-6 parsed-content">
                            <div dangerouslySetInnerHTML={{ __html: panel }} />
                        </Disclosure.Panel>
                    </dt>
                </>

            )}
        </Disclosure>
    )
}